(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .factory('PanelRegistry', PanelRegistry);

    function PanelRegistry(lodash) {
        let panels = {};
        return {
            register: register,
            clear: clear,
            refresh: refresh,
            get: get
        };

        function register(id, panel) {
            lodash.set(panels, id, panel);
        }

        function clear() {
            panels = {};
        }

        function refresh(id, panel) {
            lodash.set(panels, id, panel);
        }

        function get(id, path) {
            return lodash.get(panels, [id, path].join('.'), {});
        }

    }
})();